export const WIZARD_STEP_NAMES = {
  MODAL: {
    2: "beneficiaries",
    3: "goals",
    4: "contributions",
    5: "investment_profile",
    6: "summary",
    7: "setup_complete",
  },
  NON_MODAL: {
    1: "introduction",
    2: "beneficiaries",
    3: "goals",
    4: "contributions",
    5: "investment_profile",
    6: "summary",
    7: "setup_complete",
  },
} as const;
